import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import { 勘定科目Api, 勘定科目ListItemResponse } from '@/openapi/user';

import UserApiUtility from '@/classes/common/UserApiUtility';
import 勘定科目ListEditMixin from '@/components/勘定科目/listEdit/勘定科目ListEditMixin';
import 勘定科目UpdateOrderCheckerMixin from '@/entries/user/mixins/勘定科目UpdateOrderCheckerMixin';
import AlertMixin from '@/mixins/AlertMixin';
import EventObserverMixin from '@/mixins/EventObserverMixin';

export default mixins(AlertMixin, EventObserverMixin, 勘定科目ListEditMixin, 勘定科目UpdateOrderCheckerMixin).extend({
  name: 'C勘定科目ListEditItemButtons',

  props: {
    listItem: {
      type: Object as PropType<勘定科目ListItemResponse>,
    },
  },

  methods: {
    async updateOrder(): Promise<void> {
      await UserApiUtility.ogApi(勘定科目Api).update勘定科目並び順(this.listItem.pk);
      this.publishEvent();
    },
    async remove(): Promise<void> {
      const isCancel = await this.isCancelOrValidationErrorResponseToDelete(() =>
        UserApiUtility.ogApi(勘定科目Api).delete勘定科目(this.listItem.pk)
      );
      if (!isCancel) this.publishEvent();
    },
  },
});
